// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import delay from '../../../common/utils/lib/delay';
import { getErrorDisplayMessageFromResponse, getErrorMessageFromResponse } from '../../utils/errorUtil';

// Components
import SimplePasswordInput from '../../components/form/fields/SimplePasswordInput';
import StyledButton from '../../components/buttons/StyledButton';
import Spinner from '../../components/loaders/Spinner';
import PrimaryErrorMessage from '../../components/form/messages/PrimaryErrorMessage';

// Analytics
import * as analyticsTimingService from '../../analytics/timingService/analyticsTimingService';
import { NewRelicPageActions } from '../../analytics/newRelicUtils';

// Styles
import './BoardPasswordProtectedForm.scss';

const BoardPasswordProtectedFormUI = (props) => {
    const { dispatchOnMountDataFetch, dispatchOnSubmit, onSuccess } = props;

    const [submitting, setSubmitting] = React.useState(false);
    const [password, setPassword] = React.useState('');
    const [error, setError] = React.useState(null);

    const passwordRef = React.useRef();

    const focusPasswordInput = () => passwordRef.current?.focus();

    React.useEffect(() => {
        analyticsTimingService.cancelOperation(NewRelicPageActions.BOARD_NAVIGATION);
        dispatchOnMountDataFetch(props);
        focusPasswordInput();
    }, []);

    const onPasswordChange = (newPassword) => {
        setPassword(newPassword);
        setError(null);
    };

    const onSubmit = async () => {
        setSubmitting(true);

        try {
            await dispatchOnSubmit({ password });
            onSuccess && onSuccess();
        } catch (err) {
            const errorMessage =
                getErrorDisplayMessageFromResponse(err) ||
                getErrorMessageFromResponse(err) ||
                'The password is incorrect';
            await delay(1000);
            setError(errorMessage);
            setSubmitting(false);
            focusPasswordInput();
        }
    };

    return (
        <div className="BoardPasswordProtectedForm" onClick={focusPasswordInput}>
            <div className="form-content">
                <h2 className="password-input-heading">Enter password to view this board</h2>
                <SimplePasswordInput
                    ref={passwordRef}
                    value={password}
                    disabled={submitting}
                    hasError={!!error}
                    onChange={onPasswordChange}
                    onSubmit={onSubmit}
                />
                <StyledButton className="primary thin" onClick={onSubmit} disabled={submitting || !password}>
                    {submitting ? <Spinner show /> : 'Unlock board'}
                </StyledButton>
                <PrimaryErrorMessage message={error} show={!!error} />
            </div>
        </div>
    );
};

BoardPasswordProtectedFormUI.propTypes = {
    dispatchOnMountDataFetch: PropTypes.func,
    dispatchOnSubmit: PropTypes.func,

    onSuccess: PropTypes.func,
};

export default BoardPasswordProtectedFormUI;
